import { toastSuccess } from '../utils/toastMessage';
import { getCalculateCBGU } from './calculateCbgu';
import {
  getUserMenus,
  getUserMenusSuccess,
  setComplexMenuId,
  setSameDaysCount,
  setMenuMenuGenerator,
} from './menu';
import { showAllMenus } from './menuFilter';
import get from '../utils/get-value';
import errorHandler from '../utils/errorHandler';
import {
  getUserIdFromQueryParams,
  setQueryParameter,
  deleteQueryParameter,
} from '../utils/url-params';
import { getComplexes } from './complex';
import * as constants from '../constants/constants';

import { getDefaultMenu } from '../constants/appConstants';
import API from '../utils/API';

export const toggleIsUsersDataLoading = () => {
  return {
    type: constants.TOGGLE_IS_USERS_DATA_LOADING,
  };
};

export const GetUsersSuccess = (data) => {
  return {
    type: 'GET_USERS_SUCCESS',
    data,
  };
};

export const selectUser = (data) => {
  return {
    type: 'SELECT_USER',
    data,
  };
};

export const userToProps = (user) => {
  return {
    type: 'USER_TO_PROPS',
    user,
  };
};

export const toggleIsUserDataLoading = () => {
  return { type: constants.TOGGLE_USER_DATA_LOADING };
};

export const resetUserData = (inMenuList) => {
  return (dispatch) => {
    dispatch(toggleIsUserDataLoading());
    dispatch(userToProps({}));
    dispatch(setComplexMenuId(-1));
    inMenuList && dispatch(showAllMenus());
    inMenuList && dispatch(getUserMenusSuccess([]));
    dispatch(setMenuMenuGenerator(getDefaultMenu()));
    deleteQueryParameter('user');
    deleteQueryParameter('complex');
  };
};

export const getUser = (userId, inMenuList = false) => {
  return (dispatch) => {
    dispatch(toggleIsUserDataLoading());
    if (!userId) {
      dispatch(resetUserData(inMenuList));
      return;
    }
    setQueryParameter('user', userId);
    API.get(`/users/${userId}`)
      .then((response) => {
        const { user } = response.data.data;
        dispatch(toggleIsUserDataLoading());
        dispatch(
          getCalculateCBGU({
            age: get(user, 'params.age') ? get(user, 'params.age') : 0,
            weight: get(user, 'params.weight') ? get(user, 'params.weight') : 0,
            height: get(user, 'params.height') ? get(user, 'params.height') : 0,
            activity_id: get(user, 'params.activity.id') ? get(user, 'params.activity.id') : 0,
            gender_id: get(user, 'params.gender.id') ? get(user, 'params.gender.id') : 3,
          }),
        );
        if (!user.params) {
          user.params = {
            age: 0,
            weight: 0,
            height: 0,
            activity: { id: 1 },
            gender: { id: 3 },
            activity_id: 1,
            gender_id: 1,
          };
        }

        dispatch(userToProps(user));
        dispatch(setSameDaysCount('0'));
        if (inMenuList) {
          dispatch(showAllMenus());
          dispatch(getUserMenus(user.id));
        } else {
          dispatch(getComplexes(user.id));
        }
      })
      .catch(function (error) {
        dispatch(resetUserData(inMenuList));
        const errorConfig = {
          404: {
            message: 'Информация о выбранном пользователе не найдена',
          },
        };
        if (error && error.response && error.response.status)
          errorHandler(error.response.status, errorConfig);
      });
  };
};

export const getUsers = (userActionResult = false, inMenuList = false) => {
  return (dispatch) => {
    API.get('/users')
      .then((response) => {
        userActionResult && toastSuccess();
        dispatch(GetUsersSuccess(response.data.data.items));
        const selectedUserIdFromQueryParams = getUserIdFromQueryParams();
        if (selectedUserIdFromQueryParams) {
          dispatch(getUser(selectedUserIdFromQueryParams, inMenuList));
        }
      })
      .catch(function (error) {
        const errorConfig = {
          404: {
            message: 'Пользователи не найдены',
          },
        };
        if (error && error.response && error.response.status) {
          errorHandler(error.response.status, errorConfig);
        }
      });
  };
};

export const getMatchedUsers = (usernameValue) => {
  const queryParam = Number.isInteger(+usernameValue) ? 'id' : 'name';
  return (dispatch) => {
    dispatch(toggleIsUsersDataLoading());
    API.get(`/users?${queryParam}=${usernameValue}`)
      .then((response) => {
        dispatch(GetUsersSuccess(response.data.data.items));
      })
      .catch(() => {
        dispatch(toggleIsUsersDataLoading());
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/users.js